import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { User } from '#users/types/user.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves a list of data processors (users) from the mailing API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array of {@link User} objects.
 * @throws Throws an error if the request fails.
 */
export const getDataProcessors = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<User[]>>(formatString(Uri.mailing.getDataProcessors)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
